import { Box, styled, Typography } from "@mui/material";
import { DefaultUrlWeb } from "config/Configuration";

function CoinSelectItem({ data }) {
  return (
    <CoinSelectItemWrapper>
      <img
        width="20px"
        height="20px"
        src={DefaultUrlWeb + data?.imageUrl}
        alt=""
      />
      <Typography variant="h6">{data?.name}</Typography>
    </CoinSelectItemWrapper>
  );
}
const CoinSelectItemWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  img: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
}));
export default CoinSelectItem;
